import React, { useState, useEffect } from 'react'
import TopHeading from '../Heading/TopHeading';
import { Link } from 'react-router-dom';
import PendingChildrenItem from '../Children/PendingChildrenItem';
import GraphBox from './GraphBox';
import { Loader, NoContent, Pagination } from '../UI';
import axios from '../../axios';
import { toast } from 'react-toastify';

export default function AdminDashboardContent() {
    const authToken = localStorage.getItem('access_token');
    const [children, setChildren] = useState([]);
    const [currentChildren, setCurrentChildren] = useState([]);
    const itemsPerPage = 10;
    const [isLoading, setIsLoading] = useState(true);
    const [incomeGraph, setIncomeGraph] = useState({
        labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        values: ["0", "0", "0", "0", "0", "0", "0",]
    });
    const [earnings, setEarnings] = useState({});

    function getLastWeekDates() {
        const today = new Date();
        const lastWeekStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 6);
        const lastWeekEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
        const lastWeekDates = [];
        for (let d = new Date(lastWeekStart); d <= lastWeekEnd; d.setDate(d.getDate() + 1)) {
          lastWeekDates.push(d.toISOString().slice(0, 10));
        }
        return lastWeekDates;
    };

    const fetchChildren = () => {
        axios.get('/children', {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        })
        .then((response) => {
          if (response.data) {
            setChildren(response.data.filter(child => child.status === 'pending'));
            setIsLoading(false);
          }
        })
        .catch((error) => {
          toast.error('Couldn\'t load children');
          setIsLoading(false);
        })
    };

    const fetchGraphData = () => {
        axios.get('/lastweek-bookings', {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        })
        .then((response) => {
          if (response.data) {
            if (response.data.length) {
                let weekDates = getLastWeekDates();
                let matched = false;
                let matchedVal;
                let tempData = [...incomeGraph];
                for (let i = 0; i < weekDates.length; i++) {
                    response.data.forEach(item => {
                        if (item.date === weekDates[i]) {
                            matched = true;
                            matchedVal = item.total;
                        }
                    });
                    if (matched === true) {
                        tempData.values[i] = matchedVal;
                    }
                    matched = false;
                }
                setIncomeGraph(tempData);
            }
            setIsLoading(false);
          }
        })
        .catch((error) => {
          toast.error('Couldn\'t load Graph data');
          setIsLoading(false);
        })
    };

    const fetchEarnings = () => {
        axios.get('/lastweek-month-earnings', {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        })
        .then((response) => {
          if (response.data) {
            setEarnings(response.data);
            console.log(response.data);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          toast.error('Couldn\'t load earnings');
          setIsLoading(false);
        })
    };
    
    useEffect(() => {
        fetchChildren();
        fetchGraphData();
        fetchEarnings();
    }, []);

    return (
        <section className='admin-dashbaord-content'>
            <div className='container'>
                <div className='row g-0'>
                    <div className='col-md-12'>
                    <TopHeading title='Dashboard' />
                    <div className='row g-0 banner p-4 mb-3 corner-radius'>
                        <div className='col-md-9'>
                            {
                                isLoading ? <Loader /> : <GraphBox content={incomeGraph} />
                            }
                        </div>
                        <div className='col-md-3'>
                            <div className='total-box p-2 mb-3 corner-radius'>
                                <h6 className='yellow-text'>Last Week</h6>
                                <h2>£{
                                    (earnings && earnings.weekEarning) ? (
                                        earnings.weekEarning
                                    ) : (
                                        0
                                    )
                                }</h2>
                            </div>
                            <div className='total-box p-2 corner-radius'>
                                <h6 className='green-text'>This Month</h6>
                                <h2>£{
                                    (earnings && earnings.monthEarning) ? (
                                        earnings.monthEarning
                                    ) : (
                                        0
                                    )
                                }</h2>
                            </div>
                        </div>
                    </div>
                    <div className='my-children corner-radius pt-3 pe-2 mb-3 custom-scrollbar'>
                        <div className='d-flex justify-content-between mb-4'>
                            <h5 className='mb-0 me-2'>Pending Child Registrations</h5>
                            <Link to={'/children'} className='link-btn link-font-size'>View All</Link>
                        </div>
                        <div className='list-table table-responsive'>
                            <table className='table align-middle mb-0 table-borderless'>
                                <thead className='primary-button fw-bold'>
                                    <tr>
                                        <td className='ps-3 py-2'>Sr No.</td>
                                        <td className='py-2'>Child Name</td>
                                        <td className='py-2'>Parent Name</td>
                                        <td className='py-2'>Date Applied</td>
                                        <td className='text-end pe-3 py-2'>Action</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        isLoading ? (
                                            <tr>
                                                <td colSpan={5}>
                                                    <Loader />
                                                </td>
                                            </tr>
                                        ) : (
                                            children.length === 0 ? (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <NoContent />
                                                    </td>
                                                </tr>
                                            ) : (
                                                children.length > itemsPerPage ? (
                                                    currentChildren.map((item, index)=>{
                                                        return(
                                                            <PendingChildrenItem data={item} key={item.childId} srNo={index+1} />
                                                        )
                                                    })
                                                ) : (
                                                    children.map((item, index)=>{
                                                        return(
                                                            <PendingChildrenItem data={item} key={item.childId} srNo={index+1} />
                                                        )
                                                    })
                                                )
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                            {
                              children.length > itemsPerPage &&
                                <div className='d-flex justify-content-end'>
                                  <Pagination
                                    data={children}
                                    setCurrentItems={setCurrentChildren}
                                    itemsPerPage={itemsPerPage}
                                  />
                                </div>
                            }
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
